import { useState } from 'react';
import api from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import Table, { Column } from '../components/Table';

const REPORTS = [
  { key: 'leave-status', label: 'Leave Status Report' },
  { key: 'leave-history', label: 'Leave History Report' },
  { key: 'leave-consolidate', label: 'Leave Consolidate Report (Current Year)' },
] as const;

export default function LeaveReports() {
  const [active, setActive] = useState<(typeof REPORTS)[number]>(REPORTS[0]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [financialYear, setFinancialYear] = useState(String(new Date().getFullYear()));
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const buildParams = () => {
    if (active.key === 'leave-consolidate') return { financialYear };
    return { fromDate: fromDate || undefined, toDate: toDate || undefined };
  };

  const run = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/lms/reports/${active.key}`, { params: buildParams() });
      setRows(res.data.report || []);
    } finally {
      setLoading(false);
    }
  };

  const exportExcel = async () => {
    const res = await api.get(`/lms/reports/${active.key}`, { params: { ...buildParams(), format: 'excel' }, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${active.key}.xlsx`;
    a.click();
  };

  const columns: Column<any>[] = rows.length > 0 ? Object.keys(rows[0]).map((k) => ({ key: k, header: k.replace(/_/g, ' ').toUpperCase() })) : [];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Leave Reports</h1>
      <div className="flex gap-2 mb-4 border-b overflow-x-auto">
        {REPORTS.map((r) => (
          <button
            key={r.key}
            onClick={() => { setActive(r); setRows([]); }}
            className={`px-4 py-2 text-sm whitespace-nowrap ${active.key === r.key ? 'border-b-2 border-blue-600 text-blue-600 font-medium' : 'text-gray-500'}`}
          >
            {r.label}
          </button>
        ))}
      </div>
      <div className="flex gap-4 items-end mb-4">
        {active.key === 'leave-consolidate' ? (
          <Input label="Financial Year" value={financialYear} onChange={(e) => setFinancialYear(e.target.value)} />
        ) : (
          <>
            <Input label="From Date" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            <Input label="To Date" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </>
        )}
        <Button onClick={run}>Preview</Button>
        <Button variant="secondary" onClick={exportExcel}>Export to Excel</Button>
      </div>
      <Table columns={columns} rows={rows} loading={loading} emptyMessage="Run a report to preview results" />
    </div>
  );
}
